
import React, { useEffect, useState, useContext, Fragment } from 'react';
import {isNumeric,isMonthAndYearEmpty,getStatusFlagValue,getButtonDisabledStates} from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';



function RuralAndUrbanCommonSixItemsRetailPriceData({ 
  payload,
  sectorCode,
  monthName,
  yearName,
  urbanAndRuralCommonItemPrice,
  userInfoObject,
  resetMothAndYearField,
  config,
  type}) {



      const navigate = useNavigate();
      const [itemData, setItemData] = useState({});
      let subGroupsSerialNumber = 0;
      let ItemSerialNumber = 0;
      let isDisable=false;
      const {
        isSaveBtnDisable,
        isAcceptBtnDisable,
        } = getButtonDisabledStates(payload, userInfoObject);
        let headQuarterRemark=['Price is Too Low',
         'Price is too High',
        'Price does not match with unit' ,
        'Price does not match with variety',
        'Other.'
       ]
    let otherRemark=[
      'Production is low',
      'Production is high',
      'Less supply',
      'Not Available.',
      'On sale.',
      'Seasonal effect',
      'Discounted Item',
      'Other.'

    ]
     
const renderHeader = (i) => (
    <thead key={`thead-${i}`}>
      <tr>
        <th>Sl.No</th>
        <th>Code</th>
        <th>Item Categories</th>
        <th>Variety</th>
        <th>Unit</th>
        <th>Current Price</th>
        <th>Remarks</th>
        <th>Reject<br />Status</th>
      </tr>
    </thead>
  );

  const majorGroupRow =(i,mjgroup)=>(
      <tr  key={`tbody-majorGroup-${i}`}>
        <td>
            <div className="sub_child">
                <span className="star">*  </span> <input type="text" id={`superSlno${i + 1}`} className="form-control" disabled
                    maxLength="3" value={i + 1}/>
            </div>
        </td>
        <td><input type="text" id={`majorGroupCode${i + 1}`} className="form-control" disabled maxLength="3" value={mjgroup.majorGroupCode}/></td>
        <td><input type="text" id={`majorGroupName${i + 1}`} className="form-control" disabled maxLength="50" value={mjgroup.majorGroupName}/></td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>

   )  

  const subGroupRow =(subGroupsSerialNumber,i,j,sbgroup)=>(
    <tr key={`row-${j}-${subGroupsSerialNumber}`}>
        <td>
            <div className="sub_child">
                <span className="star">**</span> <input type="text" id={`subSlno${subGroupsSerialNumber}`} className="form-control" disabled
                    maxLength="3" value={subGroupsSerialNumber}/>
            </div>
        </td>
        <td><input type="text"  id={`subGroupCode${subGroupsSerialNumber}`} className="form-control" disabled maxLength="3" value={sbgroup.subGroupCode}/></td>
        <td><input type="text" id={`subGroupName${subGroupsSerialNumber}`}  className="form-control" disabled maxLength="50"
                value={sbgroup.subGroupName}/></td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
    </tr>
   )




  const handlePriceChange = (itemCode, field, newValue) => {  
     
      if(!(isMonthAndYearEmpty(monthName,yearName))){
         return;
      }
      
     let isRequiredRemark=false;

    if(field==='currentPrice' && !isNumeric(newValue)){
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue='';
    }
    
   
   
  if(field==='remark' && itemData[itemCode].isRequiredRemark===false 
    && (newValue==='' || itemData[itemCode].remark==='' || 
    itemData[itemCode].style.borderColor==="rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red")){
      isRequiredRemark=true
   
    }
 

  setItemData(prevItemData => {
    const updatedItemData = {
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: newValue,
        'isRequiredRemark': isRequiredRemark
      }
    };
  
    return updatedItemData;
  });
   
  
  };

  
  useEffect(() => {
    const initialData = {};
    urbanAndRuralCommonItemPrice.forEach(group => {
      group.subGroups.forEach(subGroup => {
        subGroup.itemCodes.forEach(item => {
          initialData[item.itemCode] = {
            currentPrice: item.currentPrice,
            remark: item.remark,
            statusFlag:item.statusFlag,
            style: {
              borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
              borderStyle: 'solid',
              borderWidth: '1px 1px 1px 3px'
            },
            isRequiredRemark:false,
            isRejectStatus:false
            
          };
        });
      });
    });
    setItemData(initialData);
  }, [urbanAndRuralCommonItemPrice]);



  const validateItemVariationPrice=(itemCode, field, newValue, average,variation)=>{

    if(!(isMonthAndYearEmpty(monthName,yearName))){
      return;
    }

  let dynamicStylesForTextBox={}
  let isRequiredRemark=false

    if ( newValue !== 0) {
        let dif = average * variation / 100;
          if (variation === 0 || dif === 0) {
              return;
          }
        if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
            toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
             dynamicStylesForTextBox={
              borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
              borderStyle: 'solid',
              borderWidth: '1px 1px 1px 6px'
            }
            newValue=dynamicStylesForTextBox
            if(itemData[itemCode].remark ==='No' || itemData[itemCode].remark===''){
              isRequiredRemark=true
            }

      } else {

          dynamicStylesForTextBox={
            borderColor: '#dcdfe1',
            borderStyle: 'solid',
            borderWidth: '1px 1px 1px 6px'
          }
          isRequiredRemark=false
          newValue=dynamicStylesForTextBox
          

      }
  }

   
      setItemData(prevItemData => ({
        ...prevItemData,
        [itemCode]: {
          ...prevItemData[itemCode],
          [field]: newValue,
          'isRequiredRemark': isRequiredRemark
        }
      }));

  }


  
  const handleCheckboxChange=(itemCode,field,newValue)=>{
      if(!(isMonthAndYearEmpty(monthName,yearName))){
        return;
    }
        setItemData(prevItemData => ({
            ...prevItemData,
            [itemCode]: {
              ...prevItemData[itemCode],
              [field]: !prevItemData[itemCode][field] 
            }
          }));

   }


   const handleGetUrbanConsumerPriceFormData = async (e, buttonType) => {
  
    const customItemCodes = [];
    let check = 0;
    let statusFlag = '';
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
        return;
    }
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

    for (let itemId in itemData) {
        let currentPrice = itemData[itemId].currentPrice ;
        let remark = itemData[itemId].remark;
        let isRequiredRemark = itemData[itemId].isRequiredRemark;
        let isRejectStatus = itemData[itemId].isRejectStatus;
        statusFlag = (itemData[itemId].statusFlag === '') ?
            clickButtonStatusFlag :
            itemData[itemId].statusFlag; //data base Statusflag

            if (buttonType === "SAVE" ) {
              if (isRequiredRemark) {
               toast.error(messages.REMARK_MSG, messages.COLOR_RED);
               return false;
             }
             statusFlag = clickButtonStatusFlag
           }

        if (buttonType === "REJECT" && isRejectStatus) { //Reject Button click
            check++;
            if (isRequiredRemark) {
                toast.error(messages.REMARK_MSG, messages.COLOR_RED);
                return false;
            }
            statusFlag = clickButtonStatusFlag;
        }

        if (buttonType === "ACCEPT") { //Accept Button click
            statusFlag = clickButtonStatusFlag;
        }

        if (currentPrice === '' || currentPrice === null || currentPrice === undefined) {
            toast.error(messages.CURRENT_PRICE_MSG, messages.COLOR_RED);
            return false;
        }
        if (isRequiredRemark && (remark === 'NO' || remark === '')) {
            toast.error(messages.REMARK_MSG, messages.COLOR_RED);
            return false;
        }

        if (remark === '' || remark == null) {
            remark = 'NO';
        }

        const customObject = {
            itemCode: itemId,
            currentPrice: currentPrice,
            remark: remark,
            status: isRejectStatus,
            statusFlag: statusFlag
        };
        customItemCodes.push(customObject);
    };

    if (buttonType === "REJECT" && check === 0) {
        toast.error(messages.CHECKBOX_REJECTION_MSG, messages.COLOR_RED);
        return false;
    }

    let postData = {
        itemCodes: customItemCodes,
        payload: {
            sector_code: sectorCode,
            month_name: monthName,
            year_name: yearName,
            buttonType: buttonType,
            statusFlag: clickButtonStatusFlag
        }
    };
    let url = 'getUrbanSixCommonItemPriceInputFormDataSaveToDB';
    if (type === 'rural') {
        url = 'getRuralSixCommonItemPriceInputFormDataSaveToDB';
    }

   

    showLoading(true);
    try {
        const response = await axios.post(`${API_URL}api/consumerRetail/${url}`, postData, config);
        if (response.data.status) {
            toast.success(response.data.message, messages.COLOR_RED);
        }
    } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
        showLoading(false);
        resetForm();
    }
}



   const resetForm=()=>{

    const initialData = {};
    urbanAndRuralCommonItemPrice.forEach(group => {
      group.subGroups.forEach(subGroup => {
        subGroup.itemCodes.forEach(item => {
          initialData[item.itemCode] = {
            currentPrice: '',
            remark: '',
            style: '',
            isRequiredRemark:false,
            isRejectStatus:false
            
          };
        });
      });
    });
    setItemData(initialData);
    resetMothAndYearField()
 }

 const checkBoxcheckedLength=()=>{
 
    const filteredData = Object.fromEntries(
      Object.entries(itemData).filter(([key, value]) => value.isRejectStatus === true)
    );
    return Object.keys(filteredData).length

 }


  return [
    <>
    {/* <ToastContainer/> */}
    <div className="card-body">
        <div className="table-responsive">
          <table  className="table table-bordered consumer_retail_table">

            { urbanAndRuralCommonItemPrice && urbanAndRuralCommonItemPrice.map((mjgroup,i)=>{
              
                return  <React.Fragment>
                    {renderHeader(i)}
                    <tbody>
                    {majorGroupRow(i,mjgroup)}
                    
                    { mjgroup.subGroups.map((sbgroup,j)=>{
                          subGroupsSerialNumber++;
                          
                        return   <React.Fragment key={`subGroupFragment-${i}-${j}`}>

                                    {subGroupRow(subGroupsSerialNumber,i,j,sbgroup)}
                                
                        { sbgroup.itemCodes.map((item,k)=>{
                        
                               ItemSerialNumber++
                              if(checkBoxcheckedLength() > 0){
                                isDisable =true
                              } else if(isAcceptBtnDisable){
                                 isDisable =true
                              }
                              
                             
                              return    <tr key={`row-${j}-${ItemSerialNumber}`}>
                                          <td><input type="text" id={`itemSlno${ItemSerialNumber}`} className="form-control" maxLength="3" value={ItemSerialNumber} disabled/></td>
                                          <td><input type="text" id={`itemCode${ItemSerialNumber}`} className="form-control" maxLength="3" value={item.itemCode} disabled/></td>
                                          <td><input type="text" id={`itemName${ItemSerialNumber}`} className="form-control" maxLength="50" value={item.itemName}
                                                  disabled/>
                                          </td>
                                          <td><input type="text" id={`varietyName${ItemSerialNumber}`} className="form-control" maxLength="50" value={item.variety} disabled/>
                                          </td>
                                          <td>
                                          {/* ***********unitData********* */}
                                               <select 
                                                value={item.itemUnitCode} 
                                                id={`itemUnit${ItemSerialNumber}`}
                                                name={`itemUnit${ItemSerialNumber}`} 
                                                className="form-select"
                                                disabled
                                                 >
                                                  <option key={item.itemUnitCode}>{item.itemUnitName}</option>
                                              </select>

                                          </td>
                                          <td>
                                              <input type="text" 
                                                style={itemData[item.itemCode]?.style || {}}
                                                key={ItemSerialNumber}
                                                className="form-control" 
                                                maxLength="12"
                                                name={`currentPrice_${[item.itemCode]}`}
                                                id={`currentPrice${item.itemCode}`}
                                                value={itemData[item.itemCode]?.currentPrice || ''}
                                                onChange={e => handlePriceChange(item.itemCode, 'currentPrice', e.target.value)}
                                                onBlur={e=>validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value),item.average,item.variationLimit)}
                                                />
                                          </td>
                                          <td>
                                        {
                                        userInfoObject.userLevel === "HEAD QUARTER" ?
                                        item.remark !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.remark) &&
                                        otherRemark.includes(itemData[item.itemCode]?.remark) &&
                                          <label className="text-danger" style={{ fontSize: '12px' }}>*{item.remark}</label>
                                        
                                        :
                                        item.remark !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.remark) &&
                                        headQuarterRemark.includes(itemData[item.itemCode]?.remark) &&
                                          <label className="text-danger" style={{ fontSize: '12px' }}>*{item.remark}</label>
                            
                                        }
                                          <select 
                                          name={`remark_${ItemSerialNumber}`} 
                                          id={`remark${ItemSerialNumber}`}
                                          className="form-select"
                                          value={itemData[item.itemCode]?.remark || ''}
                                          onChange={e => handlePriceChange(item.itemCode, 'remark', e.target.value)}
                                          >
                                          <option value="">[---Select---]</option>
                                          { userInfoObject.userLevel === "HEAD QUARTER" ?
                  
                                              headQuarterRemark.map((remarkItem,i)=>{
                                                return (
                                                <option value={remarkItem} key={i}>{remarkItem}</option>
                              
                                              )})
                                              :
                                    
                                              otherRemark.map((remarkItem,i)=>{
                                                return (
                                                <option value={remarkItem} key={i}>{remarkItem}</option>
                              
                                              )})
                                          }
                                        </select>

                                          {(itemData[item.itemCode]?.isRequiredRemark !== undefined && itemData[item.itemCode]?.isRequiredRemark) ?
                                            (
                                              <div style={{ color: 'red', marginTop: '10px' }}>
                                                Please Select the Remark
                                              </div>
                                            )
                                            :
                                            ''
                                          }
                                          </td>
                                          <td>
                                            <input 
                                            type="checkbox" 
                                            name={`status${ItemSerialNumber}`} 
                                            id={`status${ItemSerialNumber}`}
                                            // disabled= {isItemCodeInArray ? 'disabled' :''}
                                            onChange={(event)=>handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.value)}
                                            checked={itemData[item.itemCode]?.isRejectStatus || false}
                                           
                                            />
                                            </td>
                                        </tr>
                                    
                          
                            })}
                      
                      </React.Fragment>
                        
                          
                        })}


                    </tbody>
                        </React.Fragment>

               })

            }

        </table>
      </div>
     
                <div className="row">
                    <div className="col-12 text-center pt-3">
                        { 
                          (userInfoObject.userLevel==='HEAD QUARTER') && 
                          <button 
                            onClick={(e)=>handleGetUrbanConsumerPriceFormData(e,'SAVE')} 
                            type="button" 
                            className={`btn btn_orange mx-1 ${isSaveBtnDisable?'disabled':''}`} 
                           >
                            Save
                          </button>
                        }
                       
                      { 
                        (userInfoObject.userLevel==='HEAD QUARTER') && 
                         <>
                        
                         <button 
                         onClick={(e)=>handleGetUrbanConsumerPriceFormData(e,'ACCEPT')}   
                         type="button" 
                         className={`btn btn_orange mx-1 ${isDisable? 'disabled':''}`}
                         >Accept
                         </button>
                         </>
                      }

                        <button 
                           type="reset" 
                           className="btn btn_orange mx-1" 
                           onClick={resetForm} 
                          >
                          Reset
                        </button>
                        <button 
                          type="button" 
                          className="btn btn_orange mx-1" 
                          onClick={(e)=>( navigate("/dashboard"))}
                         >
                          Cancel
                        </button>
                    </div>
                 </div>

  </div>

    </>
  ]
}

export default RuralAndUrbanCommonSixItemsRetailPriceData